import { ApiErrorResponse } from '@/types/api/common';

export const errorHandler = (errorInfo: ApiErrorResponse): string => {
  const defaultMsg = 'Something went wrong. Please try again later.';

  const { statusCode, error } = errorInfo.response?.data || {
    statusCode: 500,
    error: {
      message: defaultMsg,
      error: defaultMsg,
      statusCode: 500,
    },
  };

  if (statusCode === 500) return defaultMsg;
  if (typeof error.message === 'string') return error.message;
  if (Array.isArray(error.message)) return error.message.join(', ');

  return defaultMsg;
};
